import { render, staticRenderFns } from "./percent.vue?vue&type=template&id=41a96b5f&scoped=true&lang=pug&"
import script from "./percent.vue?vue&type=script&lang=js&"
export * from "./percent.vue?vue&type=script&lang=js&"
import style0 from "./percent.vue?vue&type=style&index=0&id=41a96b5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a96b5f",
  null
  
)

/* custom blocks */
import block0 from "./percent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports